import {LogaProxy} from "./LogaProxy";

export class StoreListingAvailability {
  logaDay: number;
  label: string;
  shortLabel: string;
  openForPlanning: boolean;
  alreadyPlanned: boolean;
  openForPlanningDetails: string;
}

export class Store {


  public id: number;
  public code: string;
  public name: string;
  public address: Address;
  public retailer: number;

  public clientCode: string;
  public resourcePool: string;

  public planningAvailabilities: StoreListingAvailability[] = [];

  public uiRetailer: Retailer;
  public uiShouldBeHidden: boolean;

  public notOpenForOrdering: boolean;
  public notOpenForOrderingDetails: string;


  static fromStoreLocation(location: StoreLocation) {
    const o: Store = new Store();
    o.id = location.id;
    o.retailer = location.retailerId;
    o.uiRetailer = location.retailer;
    o.address = location.address;
    o.name = location.name;
    o.code = location.code;
    o.clientCode = location.clientCode;

    return o;
  }
}

export class StoreAlias {
  public clientCode: string;
  public customerBu: number;
  public id: number;
  public resourcePool: string;
  public store: number;
}

export class StoreLocation {
  public id: number;
  public code: string;
  public name: string;
  public address: Address;
  public retailerId: number;
  public retailer: Retailer;
  public customerSector: number;
  public customerArea: number;
  public clientCode: string;
}

export class Retailer {

  public static fromJson(json: Object): Retailer {
    const o: Retailer = new Retailer();
    o.id = json['id'];
    o.code = json['code'];
    o.name = json['name'];

    o.code = o.code.replace(" ", "").replace("/", "").trim();

    return o;
  }

  public id: number;
  public code: string;
  public name: string;

  public uiShouldBeHidden: boolean;
}


export class Address {
  public line1: string;
  public line2: string;
  public administrativeArea: string;
  public zipCode: string;
  public city: string;
  public country: string;
  public lat: number;
  public lon: number;
}

// Store Dashboard --
export class StoreActivityDay {
  logaDay: number;
  dayOfMonth: number;
  dayOfWeek: number;
  missions: number[];
  displayLabel: string;
}

export class StoreActivityWeek {
  days: StoreActivityDay[] = [];
}


export class StoreDashOperationActivityReport {
  operation: LogaProxy;
  plannedActivitiesCount: number;
  plannedHours: number;

  firstActivityDate: Date;
  lastActivityDate: Date;
  //should we hide this by entry as default behavior (for instance too old, not relevant anymore, only show if really requested)
  hiddenByDefault: boolean;
}

export class StoreDashboard {
  public store: Store;
  public storeAlias: StoreAlias;
  public activityWeeks: StoreActivityWeek[];
  public operationActivityReports: StoreDashOperationActivityReport[] = [];
}

// Store Directory --
export class StoreDirectoryLiveOperation extends LogaProxy {
  missionCount: number;
  typeOfMission: string;
}

export class StoreDirectoryListing {
  id: number;
  name: string;
  retailer: LogaProxy;
  address: Address;
  liveOperations: StoreDirectoryLiveOperation[] = [];
  storeAliasClientCode: string;
  storeAliasResourcePool: string;
  uiShouldBeHidden: boolean;
}

export class StoreDirectory {
  stores: StoreDirectoryListing[] = [];
}

export class MonthlyCalenderPreviewReport {
  public year: number;
  public month: number;
  public activityWeeks: StoreActivityWeek[];
}



// WEBPACK FOOTER //
// ./src/model/Store.ts